export default {
  // 影片類型
  TYPE_HAKKA: 'hakka', // 客家焦點
  TYPE_POLITICAL: 'political', // 政經要聞
  TYPE_MEDICAL: 'medical', // 民生醫療
  TYPE_LOCAL: 'local', // 地方風采
  TYPE_INTERNATIONAL: 'international', // 國際萬象

  // 影片子類型
  NEWS_SUBTYPE_ENTERTAINMENT: 'entertainment', //娛樂
  NEWS_SUBTYPE_INTERNAL: 'internal', //國內
  NEWS_SUBTYPE_LIFE : 'life', //生活
  NEWS_SUBTYPE_TRAVEL : 'travel', //旅遊
}